import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getVideoFileKey, getTokenDataHK2024, saveMediaFileHK2024 } from '@src/services/api';
import { Toast } from 'antd-mobile';
import { zhanden } from '@src/utils/zhanden'; 

const UploadVideo = ({ name, changeInputHandle, formData, languages }) => {
    const [uploadState, setUploadState] = useState(1);
    const [progress, setProgress] = useState(0);
    const flieWhiteList = ['mp4', 'mov', 'quicktime'];

    const fileRef = useRef();

    const clickUploadVideoFile = () => {
        const picFileDom = fileRef.current;

        picFileDom.click();
    };

    useEffect(() => {
        if (formData?.[name]) {
            setUploadState(3);

            return false;
        }
    }, [formData]);

    useEffect(async () => {
        const picFileDom = fileRef.current;

        picFileDom.addEventListener('change', async () => {
            // todo限制类型和尺寸 图片20M 视频200M
            const formData = new FormData();
            const file = picFileDom.files[0];
            const fileSize = file.size;
            const fileType = file.type.toLocaleLowerCase().split('/');
            const maxFileSize = 524288000; // 500M转换成b

            // 文件大小校验
            if (fileSize > maxFileSize) {
                Toast.show({
                    content: zhanden[languages].videoSelf.waring1,
                });

                return false;
            }

            setUploadState(2);

            // 第一步获取token
            const result = await getTokenDataHK2024(name);
            const tokenList = result?.data?.token_list;
            const transaction_id = result?.data?.transaction_id;
            const { url, token } = tokenList.pop();

            formData.append('token', token);
            formData.append('file', file);
            // 第二步上传文件
            const fileResult = await getVideoFileKey(url, formData, (progressEvent) => {
                const { loaded, total } = progressEvent;
                const precentage = Math.floor((loaded * 100) / total);

                setProgress(precentage);
            });
            const fileKey = fileResult?.data?.key || '';

            // 第三步存入表单
            await saveMediaFileHK2024(name, {
                transaction_id,
                video: fileKey,
            });

            changeInputHandle(name, transaction_id);
            setUploadState(3);
        });
    }, []);

    return (
        <>
            <div className={styles.formVideoBox} onClick={clickUploadVideoFile}>
                <input
                    ref={fileRef}
                    accept={flieWhiteList.map((item) => `video/${item}`).join(',')}
                    className={styles.formVideoUploadInput}
                    type="file"
                />
                {uploadState === 1 && <div className={styles.formVideoButton}>{zhanden[languages].videoSelf.buttonText}</div>}
                {uploadState === 2 && <div className={styles.formVideoButton}>{zhanden[languages].videoSelf.uploadText}...{progress}%</div>}
                {uploadState === 3 && <div className={styles.formVideoButton}>{zhanden[languages].videoSelf.uploadDoneText}</div>}
            </div>
        </>
    );
};

UploadVideo.propTypes = {
    name: PropTypes.string,
    formData: PropTypes.object,
    changeInputHandle: PropTypes.func,
    languages: PropTypes.string
};

export default errorBoundary(UploadVideo);
